import Flex from "common/Boxes/Flex";
import CustomInputNumber from "common/Inputs/CustomInputNumber";
import { PrecisionConfig } from "types";
import { PriceRange } from "@shared/features/tradingTerminal/common/types";
import styled from "styled-components";

interface PriceRangeInputProps {
  minMax: PriceRange;
  precisionConfig: PrecisionConfig;
  onValueChange: (priceRange: PriceRange) => void;
  isForm?: boolean;
}

const PriceRangeInput = ({
  minMax,
  precisionConfig,
  onValueChange,
  isForm = false,
}: PriceRangeInputProps) => {
  return (
    <Flex style={{ gridGap: 8 }}>
      <CustomInputNumber
        bordered={isForm}
        value={minMax.min}
        onChange={(min) => onValueChange({ ...minMax, min })}
        precision={precisionConfig.price}
        stringMode={true}
        underline={true}
        centerText={true}
        useDebounce={true}
        autoSize={true}
        minWidth={30}
        style={{ flex: 1 }}
      />
      <Divider>-</Divider>
      <CustomInputNumber
        bordered={isForm}
        value={minMax.max}
        onChange={(max) => onValueChange({ ...minMax, max })}
        precision={precisionConfig.price}
        stringMode={true}
        underline={true}
        centerText={true}
        useDebounce={true}
        autoSize={true}
        minWidth={30}
        style={{ flex: 1 }}
      />
    </Flex>
  );
};

export default PriceRangeInput;

const Divider = styled.span`
  color: ${(p) => p.theme.colors.primaryGrey};
`;
